//@ts-nocheck
import React, { createContext } from 'react';
import { Accordion, AccordionSection } from '@/generic-components/checkout/accordion';
import ContactWrapper from '../contact/contactWrapper';
import { IBasket, IEcProduct } from '@/types/simo/basket';
import DeliveryWrapper from '../delivery/deliveryWrapper';
import OverwiverWrapper from '../overview/overviewWrapper';
import PaymentWrapper from '../payment/wrapper';
import { detectSuccessfulPaymentURL } from '@/utils/helper';

/* import './styles.scss';
 */
const CheckoutContext = createContext<any>(null);
interface IProps {
  basket: IBasket;
  setBasket: React.Dispatch<React.SetStateAction<any>>;
  checkoutCms: any;
  ecProducts: IEcProduct[];
}

const CheckoutAccordion = (props: IProps) => {
  const { basket, setBasket, checkoutCms, ecProducts } = props;
  const checkoutContainer = React.createRef<HTMLDivElement>();
  const getSteps = () => {
    //As of right now we can't get basket, so we're going to betaling with no basket
    if (detectSuccessfulPaymentURL(window.location)) {
      return (
        <>
          <AccordionSection title={'Kontaktoplysninger'}></AccordionSection>
          <AccordionSection title={'Levering'}></AccordionSection>
          <AccordionSection title={'Godkend'}></AccordionSection>
          <AccordionSection title={'Betaling'}>
            <PaymentWrapper />
          </AccordionSection>
        </>
      );
    }

    return (
      <>
        <AccordionSection title={'Kontaktoplysninger'}>
          <ContactWrapper />
        </AccordionSection>
        <AccordionSection title={'Levering'}>
          <DeliveryWrapper />
        </AccordionSection>
        <AccordionSection title={'Godkend'}>
          <OverwiverWrapper />
        </AccordionSection>
        <AccordionSection title={'Betaling'}>
          <PaymentWrapper />
        </AccordionSection>
      </>
    );
  };
  return (
    <CheckoutContext.Provider
      value={{
        basket,
        setBasket,
        checkoutCms,
        ecProducts
      }}
    >
      <section ref={checkoutContainer}>
        <div className="ys-row">
          <div className="ys-col">
            <Accordion>{getSteps()}</Accordion>
          </div>
        </div>
      </section>
    </CheckoutContext.Provider>
  );
};

export { CheckoutAccordion, CheckoutContext };
